import { Row } from "react-bootstrap";
import exclamation from "../../../../assets/images/exclamation-circle.png";
const Paiement = ({ isOpenP, toggleOpenP, chevronRight }) => {
return(
    <Row>
  <div className=" px-3">
  {/* Section des paramètres visibles si isOpenS est vrai */}
  <div
              style={{
                padding: "5px",
                backgroundColor: "#FFFFFF",
                border: "1px solid #E3E3E3",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
            <span style={{
             marginLeft:'15px',
            width: "100%",
            backgroundColor: "#FFFFFF",
            fontFamily: "Poppins",
            fontSize: "20px",
            fontWeight: "500",
            color: "#070707",
            borderColor: "#0000001A",
            height: "40px",
          }}> Limites versements
          </span>
          </div>
        <div
          style={{
            padding: "20px",
            backgroundColor: "#FFFFFF",
            border: "1px solid #E3E3E3",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
      <div className="row" style={{ display: "flex", gap: "15px" }}>
        {/* Premier input */}
        <div className="col">
          <label
          className="securite-label"
            style={{
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: "400",
              color: "#00000066",
            }}
          >
           Limite quotidienne globale (XOF)
          </label>
          <input
            type="text"
            placeholder=""
            className="form-control"
            style={{
              backgroundColor: "#FFFFFF",
              borderColor: "#0000001A",
              height: "40px",
              fontFamily: "Poppins",
            }}
          />
        </div>
      </div>
<div style={{ marginTop: "20px", display: "flex", alignItems: "center", gap: "10px" }}>
  <input
    type="checkbox"
    id="PourMontantsEleves"
    style={{
      width: "18px",
      height: "18px",
      cursor: "pointer",
    }}
  />
  <div>
    <label
    className="securite-label"
      htmlFor="Pourlesmontantsélevés"
      style={{
        fontFamily: "Poppins",
        fontSize: "15px",
        fontWeight: "400",
        color: "#070707",
        cursor: "pointer",
      }}
    >
     Pour les montants élevés
    </label>
  </div>
</div>
    </div>
  <div  
   className="securite-actions"
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "25px",
    width: "100%",
  }}
>
  <div
    className="btn btn-primary"
    style={{
      display: "flex",
      alignItems: "flex-start",
      padding: "10px 15px",
      minHeight: "40px",
      backgroundColor: "#DD20250A",
      borderColor: "#DD20250A",
      borderRadius: "8px",
      fontFamily: "Poppins",
      fontSize: "15px",
      fontWeight: "500",
      boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
      maxWidth: "450px",
    }}
  >
    <img
      src={exclamation}
      alt="exclamation"
      style={{
        width: "22px",
        height: "22px",
        marginTop: "3px",
        marginRight: "8px",
      }}
    />
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <span
          style={{
            fontWeight: "600",
            fontSize: "15px",
            lineHeight: "18px",
            color: "#0E0E0FE5",
          }}
        >
          Attention 
        </span>
      </div>
      <span
        style={{
          fontSize: "13px",
          color: "#555",
          lineHeight: "18px",
          marginTop: "2px",
        }}
      >
        Certains changements peuvent affecter
      </span>
      <span
        style={{
          fontSize: "13px",
          color: "#555",
          lineHeight: "18px",
          marginTop: "2px",
        }}
      >
         les opérations en cours.
      </span>
    </div>
  </div>

  {/* BOUTONS À DROITE */}
  <div  className="securite-buttons" style={{ display: "flex", alignItems: "center", gap: "10px",  marginTop: "20px", }}>
    <button
      type="button"
      className="btn btn-primary"
      style={{
        height: "40px",
        color: "#3761FF",
        backgroundColor: "#F2F5FF",
        borderColor: "#F2F5FF",
        borderRadius: "8px",
        fontFamily: "Poppins",
        fontSize: "15px",
        fontWeight: "500",
        padding: "0 15px",
        boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      Réinitialiser
    </button>

    <button
      type="button"
      className="btn btn-primary"
      style={{
        height: "40px",
        color: "#FFFFFF",
        backgroundColor: "#3761FF",
        borderColor: "#3761FF",
        borderRadius: "8px",
        fontFamily: "Poppins",
        fontSize: "15px",
        fontWeight: "500",
        padding: "0 15px",
        boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
      }}
      >
      Enregistrer
    </button>
  </div>
</div>


</div>
    </Row>
);
};
export default Paiement;
